// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.public-page-container {
    background-image: none;

    width: 100%;
    padding: 0;
    margin: 0;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-end;
}
.login-page__logo-container {
    display: flex;
    justify-content: center;
    width: 100%;
    position: absolute;
    top: calc(100% / 3 - 140px);
    z-index: 1;
}
.login-page__logo {
    width: 165px;
}
.public-page__content-container {
    width: 100%;
    z-index: 10;
}

@media screen and (min-width: 1025px) {
    .login-page__logo {
        width: 200px;
    }
}

.public-page-container.public-page-container--desktop {
    flex-direction: row-reverse;

    align-items: center;
    background-repeat: no-repeat, no-repeat, no-repeat;
}

.login-page__logo-container--desktop {
    position: static;
    height: 100vh;
    align-items: center;
}
.login-page__login-form-container--desktop {
    height: 100%;
    min-height: 100vh;
    position: relative;
    box-sizing: border-box;
}
.login-page__login-form-container--desktop .login-form {
    min-height: 100vh;
    height: 100%;
    align-items: center;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    box-sizing: border-box;
}

.login-page__login-form-container--desktop .login-form-container {
    max-width: 407px;
}

.login-page__login-form-container--desktop .login-form__action-btn-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.login-page__login-form-container--desktop .login-form__action-btn-container .main-action-btn {
    width: 50%;
    margin-bottom: 0;
}

.public-page__intro .company-intro__wrapper--mobile {
    justify-content: flex-start;
}
.login-page__placeholder {
    width: 0;
    padding-top: var(--safe-area-top);
}
.login-page__placeholder .company-intro__logo--white {
    visibility: hidden;
}
@media screen and (max-width: 679px) {
    .login-page__placeholder {
        flex-grow: 1;
        z-index: 1;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .login-page__placeholder .company-intro__logo--white {
        visibility: visible;
    }
    .login-page__placeholder {
        width: 100%;
    }
}

.public-page-container--loading .login-page__placeholder {
    display: none;
}

.public-page-container--loading .public-page__intro .company-intro__wrapper--mobile {
    justify-content: center;
}

.public-page__content-container-content {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    width: 100%;
    background-color: white;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    padding: 30px 16px calc(env(safe-area-inset-bottom, 0));
    z-index: 10;
    align-items: center;
}

@media screen and (min-width: 680px) {
    .public-page__content-container-content {
        height: 100vh;
        padding: 30px 16px calc(env(safe-area-inset-bottom, 0));
    }
}
`, "",{"version":3,"sources":["webpack://./src/core/components/layout/PublicPageContainer/PublicPageContainer.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;;IAEtB,WAAW;IACX,UAAU;IACV,SAAS;IACT,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,2BAA2B;IAC3B,UAAU;AACd;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,2BAA2B;;IAE3B,mBAAmB;IACnB,kDAAkD;AACtD;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;AACA;IACI,QAAQ;IACR,iCAAiC;AACrC;AACA;IACI,kBAAkB;AACtB;AACA;IACI;QACI,YAAY;QACZ,UAAU;QACV,aAAa;QACb,uBAAuB;QACvB,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,WAAW;IACf;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,uBAAuB;IACvB,4BAA4B;IAC5B,6BAA6B;IAC7B,uDAAuD;IACvD,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI;QACI,aAAa;QACb,uDAAuD;IAC3D;AACJ","sourcesContent":[".public-page-container {\n    background-image: none;\n\n    width: 100%;\n    padding: 0;\n    margin: 0;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: flex-end;\n}\n.login-page__logo-container {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    position: absolute;\n    top: calc(100% / 3 - 140px);\n    z-index: 1;\n}\n.login-page__logo {\n    width: 165px;\n}\n.public-page__content-container {\n    width: 100%;\n    z-index: 10;\n}\n\n@media screen and (min-width: 1025px) {\n    .login-page__logo {\n        width: 200px;\n    }\n}\n\n.public-page-container.public-page-container--desktop {\n    flex-direction: row-reverse;\n\n    align-items: center;\n    background-repeat: no-repeat, no-repeat, no-repeat;\n}\n\n.login-page__logo-container--desktop {\n    position: static;\n    height: 100vh;\n    align-items: center;\n}\n.login-page__login-form-container--desktop {\n    height: 100%;\n    min-height: 100vh;\n    position: relative;\n    box-sizing: border-box;\n}\n.login-page__login-form-container--desktop .login-form {\n    min-height: 100vh;\n    height: 100%;\n    align-items: center;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    box-sizing: border-box;\n}\n\n.login-page__login-form-container--desktop .login-form-container {\n    max-width: 407px;\n}\n\n.login-page__login-form-container--desktop .login-form__action-btn-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n.login-page__login-form-container--desktop .login-form__action-btn-container .main-action-btn {\n    width: 50%;\n    margin-bottom: 0;\n}\n\n.public-page__intro .company-intro__wrapper--mobile {\n    justify-content: flex-start;\n}\n.login-page__placeholder {\n    width: 0;\n    padding-top: var(--safe-area-top);\n}\n.login-page__placeholder .company-intro__logo--white {\n    visibility: hidden;\n}\n@media screen and (max-width: 679px) {\n    .login-page__placeholder {\n        flex-grow: 1;\n        z-index: 1;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n    .login-page__placeholder .company-intro__logo--white {\n        visibility: visible;\n    }\n    .login-page__placeholder {\n        width: 100%;\n    }\n}\n\n.public-page-container--loading .login-page__placeholder {\n    display: none;\n}\n\n.public-page-container--loading .public-page__intro .company-intro__wrapper--mobile {\n    justify-content: center;\n}\n\n.public-page__content-container-content {\n    box-sizing: border-box;\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    background-color: white;\n    border-top-left-radius: 30px;\n    border-top-right-radius: 30px;\n    padding: 30px 16px calc(env(safe-area-inset-bottom, 0));\n    z-index: 10;\n    align-items: center;\n}\n\n@media screen and (min-width: 680px) {\n    .public-page__content-container-content {\n        height: 100vh;\n        padding: 30px 16px calc(env(safe-area-inset-bottom, 0));\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
